<template>
  <v-layout row wrap>
    <notice-alert 
      style="width: 100% !important"
      :class="{
        'ma-0': hasMainImageError,
        'mt-2': hasMainImageError
      }"
      :notice-text="getGroupNotice"
      v-if="getGroupNotice"
    />
    
    <v-flex xs12 class="group-header-container" :style="{ marginTop: bannerFullWidth ? '5px' : '20px' }">
      <div class="image-container">
        <v-img
          :src="getMainImage()"
          @error="hasMainImageError = true"
          v-if="!hasMainImageError"
          max-height="150"
          :contain="!bannerFullWidth"
          class="main-image"
        />
        
        <v-img
          v-else
          :src="getImage()"
          max-height="150"
          :contain="!bannerFullWidth"
          class="fallback-image"
        />
      </div>
      
      <div class="group-name-container">
        <h1 class="group-name">{{ getGroup.groupName }}</h1>
      </div>
    </v-flex>
  </v-layout>
</template>

<style scoped>
  .group-header-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .image-container {
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }
  
  .main-image, .fallback-image {
    max-width: 100%;
    object-fit: contain;
  }
  
  .group-name-container {
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  
  .group-name {
    font-size: var(--text-size-3);
    font-weight: 700;
  }
  
  @media all and (min-width: 960px) {
    .image-container {
      max-height: 150px;
    }
  }
  
  @media (max-width: 960px) {
    .image-container {
      max-height: 150px;
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex'
  import get from 'lodash/get';
  import NoticeAlert from "./NoticeAlert"

  export default {
    components: { NoticeAlert },

    data: () => ({
      hasMainImageError: false
    }),

    computed: {
      storeCount() {
        return get(this.getGroup, 'stores.length', 0)
      },

      bannerFullWidth() {
        return get(this.getGroup, 'settings.owaSettings.bannerSettings.fullWidth', false)
      },

      ...mapGetters([
        'getGroup',
        'getGroupNotice',
        'getStore'
      ])
    },

    methods: {
      getMainImage() {
        const imagePath = process.env.VUE_APP_API_IMAGE
        const relativePath = get(this.getGroup, 'images.MAIN[0].url')

        if (relativePath) {
          return `${imagePath}${relativePath}`
        } else {
          this.hasMainImageError = true
          return '';
        }
      },

      getImage() {
        const imagePath = process.env.VUE_APP_API_IMAGE
        const relativePath = get(this.getGroup, 'storeLogo')

        if (relativePath) {
          return `${imagePath}${relativePath}`
        }
        return '';
      }
    }
  }
</script>